import React from 'react';
import TabNavItem, { ITabNavItem } from './TabNavItem';

export interface ITab {
    id: any;
    title: string;
    classes?: string;
    icon?: JSX.Element;
    itemCount?: number;
    actions?: JSX.Element;
}

interface TabNavProps {
    tabs: ITab[];
    activeTab: string;
    setActiveTab: (id: string ) => void;
    onTabClicked?: (id: string) => void;
    classes?: string;
    page?: string;
    isPayoutTab?: boolean;
    actions?: JSX.Element;
}

const TabNav: React.FC<TabNavProps> = ({ tabs, activeTab, setActiveTab, onTabClicked, classes, page, isPayoutTab, actions }) => {
    return (
        <ul className="flex items-center  border-gray-100  dark:bg-darkBg dark:border-darkBg-border">
            {tabs.map((tab: ITab) => (
                <TabNavItem
                    key={tab.id}
                    id={tab.id}
                    title={tab.title}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    onTabClicked={onTabClicked}
                    classes={classes}
                    icon={tab.icon}
                    count={tab.itemCount}
                    page={page}
                    isPayoutTab={isPayoutTab}
                    actions={tab.actions}
                />
            ))}
        </ul>
    );
};

export default TabNav;
